import type {components} from '@/lib/api-schema'

export type MoneyRange = components['schemas']['MoneyRange']
// Solo aritmética sobre las participaciones del backend, que es la fuente del cálculo.
export type Cop = {low: number; high: number}

function millions(cop: number): string {
  return (cop / 1_000_000).toLocaleString('es-CO', {minimumFractionDigits: 1, maximumFractionDigits: 1})
}

export function formatCopMillions(cop: number): string {
  return `$${millions(cop)} M`
}

export function formatCopRange(low: number, high: number): string {
  return `${formatCopMillions(low)} – ${formatCopMillions(high)}`
}

export function formatCopRangeOf({low, high}: Cop): string {
  return formatCopRange(low, high)
}

function uvt(value: number): string {
  return value.toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})
}

export function formatUvtRange(low: number, high: number): string {
  return `${uvt(low)}–${uvt(high)} UVT`
}

export function formatCopFull(cop: number): string {
  return `$${Math.round(cop).toLocaleString('es-CO')}`
}

export function standardRisk(base: MoneyRange, weightShare: number): Cop {
  return {low: Math.floor(base.cop_low * weightShare), high: Math.floor(base.cop_high * weightShare)}
}

/** Parte de base × share sin redondear, para que las acciones nunca sumen más que su estándar. */
export function actionRisk(base: MoneyRange, weightShare: number, actionCount: number): Cop {
  if (actionCount <= 0) return {low: 0, high: 0}
  return {
    low: Math.floor((base.cop_low * weightShare) / actionCount),
    high: Math.floor((base.cop_high * weightShare) / actionCount),
  }
}

export function scaleCop({low, high}: Cop, factor: number): Cop {
  return {low: low * factor, high: high * factor}
}

export function addCop(a: Cop, b: Cop): Cop {
  return {low: a.low + b.low, high: a.high + b.high}
}

export const ZERO_COP: Cop = {low: 0, high: 0}
